import * as React from 'react';
import rnSelected from '../../../assets/react-native-selected.svg';
import rnUnselected from '../../../assets/react-native-unselected.svg';
import rnDisabledSelected from '../../../assets/react-native-disabled-selected.svg';
import rnDisabledUnselected from '../../../assets/react-native-disabled-unselected.svg';
import { IconProps } from '../../typescriptHelpers';

interface ReactNativedAppIconProps extends IconProps {
    isSelected: boolean;
    isDisabledTreatment: boolean;
}

const ReactNativeAppIcon: React.FC<ReactNativedAppIconProps> = (props: ReactNativedAppIconProps) => {
    let sourceImage = props.isSelected ? rnSelected : rnUnselected;
    if (props.isDisabledTreatment) {
        sourceImage = props.isSelected ? rnDisabledSelected : rnDisabledUnselected;
    }

    return <img src={sourceImage} width={props.width} height={props.height} />;
};

export default ReactNativeAppIcon;
